export default __webpack_public_path__ + "static/media/item-2.57d5febb.webp";